export default __webpack_public_path__ + "static/media/Spiderman_03.388b9b14.png";